import { styled } from 'styled-components'

export const SnackBarsBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  position: fixed;
  right: 50%;
  top: 3.75rem;
  transform: translate(50%, 0);
  z-index: 200;
`
